module.exports = __webpack_public_path__ + "img/fireworks.97eb621f.svg";